export default __webpack_public_path__ + "static/media/thun2.969e82d8.wav";